import { render } from "./view_resolved_requests.html?vue&type=template&id=d8e8d864&scoped=true&external"
import script from "./view_resolved_requests.js?vue&type=script&lang=js&external"
export * from "./view_resolved_requests.js?vue&type=script&lang=js&external"

import "./ViewResolvedRequests.vue?vue&type=style&index=0&id=d8e8d864&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8e8d864"]])

export default __exports__